import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ChangingProgressProvider from "./ChangingProgressProvider";

const Progress = ({ end, title, color }) => {
  return (
    <div className="progress">
      <ChangingProgressProvider values={[0, end]}>
        {percentage => (
          <CircularProgressbar
            value={percentage}
            text={title}
            styles={buildStyles({
              pathColor: color,
              textColor: "#ccc",
              trailColor: "#ccc",
              backgroundColor: "none"
            })}
          />
        )}
      </ChangingProgressProvider>
    </div>
  );
};

export default Progress;
